import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';
import { Typography } from 'src/components/new/Typography';
import PrintFileTooltipContent from './PrintFileTooltipContent';

interface PrintDocument {
  storedFile: {
    filename: string;
  };
}

interface PrintDocumentSectionProps {
  printDocuments: PrintDocument[];
}

const PrintDocumentSection = ({ printDocuments }: PrintDocumentSectionProps) => {
  if (printDocuments.length === 0) {
    return null;
  }

  return (
    <>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.375rem',
          marginTop: '0.9375rem',
          marginBottom: '0.9375rem',
        }}
      >
        <Typography sx={{ fontWeight: '600' }}>Print File Name</Typography>
        <Tooltip
          title={<PrintFileTooltipContent />}
          placement="right"
          disableInteractive={false}
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: '#ffffff',
                color: '#1a1a1a',
                boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
                border: '1px solid #e0e0e0',
                maxWidth: '30rem',
                maxHeight: '100vh',
                overflowY: 'auto',
                padding: '0.75rem 1rem',
              },
            },
          }}
        >
          <InfoOutlinedIcon sx={{ color: '#436EB2', cursor: 'pointer' }} />
        </Tooltip>
      </Box>
      <Box
        style={{
          padding: '0.9375rem',
          border: '0.0625rem solid #cac4d0',
          borderRadius: '0rem',
        }}
      >
        <Typography>
          <span style={{ fontWeight: '500' }}>Print File Name: </span>
          {printDocuments[0].storedFile.filename}
        </Typography>
      </Box>
    </>
  );
};

export default PrintDocumentSection;
